import styled from 'styled-components';

export default styled.div`
  > h2 {
    flex: 0 0 auto;

    color: ${props => props.theme.palette.primary.main};
    font-size: 2.4rem;
    font-weight: 400;

    padding-bottom: 1.6rem;
  }
`;
